import { render } from "./LogoSvg.vue?vue&type=template&id=8f3756a0"
import script from "./LogoSvg.vue?vue&type=script&lang=js"
export * from "./LogoSvg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__